import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {Product} from "../../../model/product";
import {ProductService} from "../../../service/product.service";
import {Document} from "../../../model/document";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import {ModalComponent} from "../../modal/modal.component";
import {SavedPropertyService} from "../../../service/saved-property.service";
import {SavedPropertyDocumentContainer} from "../../../model/savedPropertyDocumentContainer";
import {TimeUnit} from "../../../model/timeUnit";
import {PricingPackage} from "../../../model/pricingPackage";
import {User} from "../../../model/user";
import {Property} from "../../../model/property";
import {BookableServiceService} from "../../../service/bookable-service.service";
import {BookableService} from "../../../model/bookableService";
import {ServiceCategory} from "../../../model/serviceCategory";
import NameFinderUtils from "../../../utils/name-finder-utils";
import {Service} from "../../../model/service";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmationDialogComponent} from "../../dialogs/confirmation-dialog/confirmation-dialog.component";
import {tap} from "rxjs/operators";
import {LoginIdService} from "../../../service/login-id.service";
import {DocumentClass} from "../../../model/documentClass";
import {SubInformation} from "../../../model/subInformation";
import {HttpHeaders} from "@angular/common/http";
import {
  GrundeInformationModalComponent
} from "../../modal/specific-modals/grunde-information-modal/grunde-information-modal.component";
import {ProductValueFormComponent} from "./product-value-form/product-value-form.component";
import ProductUtils from "../../../utils/product-utils";
import {KampfmInformationComponent} from "../information-components/kampfm-information/kampfm-information.component";
import {TeilunInformationComponent} from "../information-components/teilun-information/teilun-information.component";
import {
  ResearchDepartmentInformationComponent
} from "../information-components/research-department-information/research-department-information.component";
import {BaulasInformationComponent} from "../information-components/baulas-information/baulas-information.component";
import {ComponentType} from "@angular/cdk/overlay";
import {BewilInformationComponent} from "../information-components/bewil-information/bewil-information.component";
import StaticData from "../../../utils/static-data";
import {SnackbarService} from "../../../service/snackbar.service";
import {Pricing} from "../../../model/platform/pricing";
import {PricingPackageExplicitDocument} from "../../../model/platform/pricingPackageExplicitDocument";
import {PlatformUtils} from "../../../utils/platform-utils";
import {PricingUtils} from "../../../utils/pricing-utils";
import PackageSelectionUtils from "../../../utils/package-selection-utils";
import {AdditionalConstructionFileData} from "../../../model/additionalConstructionFileData";

@Component({
  selector: 'app-products-container',
  templateUrl: './products-container.component.html',
  styleUrls: ['./products-container.component.css']
})
export class ProductsContainerComponent implements OnInit {

  private static readonly UNORDERABLE_PRODUCTS = ['bewila', 'bewild', 'bewil'];

  @Input() displayInfo: boolean = false;
  @Input() savedId: string;
  @Input() user: User;
  @Input() isAllowedToOrder: boolean = false;
  @Input() documents: Array<Document> = [];

  pricing: Pricing;
  planungSubClassNames: string[];
  products: Product[] = [];
  pbauakDocumentClass: DocumentClass;
  bauakProducts: Product[] = [];
  grundakten: Product[] = [];
  productsByCategory: Map<String, Product[]> = new Map<string, Product[]>();
  planungProductsByCategory: Map<string, Product[]> = new Map<string, Product[]>();
  preferredOrder = ["Bauaktenarchivbesuche", "Grundakte", "Digitalisierungsservice"];

  bookableServicesByCategory: Map<string, BookableService[]> = new Map<string, BookableService[]>();
  serviceCategories: ServiceCategory[] = [];

  keys: string[] = [];
  showBauaktenModal: boolean = false;
  startBauakModalOnGrundeStep: boolean = false;
  pendingBauakPackageSelection: PricingPackage | undefined;
  showBewilModal: boolean = false;
  showLeitungPricingOnRequestInformation: boolean = false;
  showDigitizationServiceInformation: boolean = false;
  leitungDocumentNameShort: string;
  showInvalidInputs: boolean = false;
  documentEntryDate = new Map();
  savedPropertyDocumentContainerList: SavedPropertyDocumentContainer[] = [];
  isSavedProperty: boolean;
  @Input() rotationOrderView: boolean = false;
  @Input() docInfo: string;
  @Input() isConnectOrigin: boolean;
  @Output() infoRequest = new EventEmitter();
  @Output() checkProperty = new EventEmitter();
  @Output() getSelectedProperty = new EventEmitter();
  @Output() updatePropertyForm = new EventEmitter();
  selectedProperty: Property;
  @ViewChild('addDigitizationServiceModal') addDigitizationServiceModalComponent: ModalComponent;
  @ViewChild('contactOverlayComponent') contactOverlayComponent: ModalComponent;
  @ViewChildren('packageHead') packageHeads: QueryList<ElementRef>;
  fixedPricingPackages: PricingPackage[];
  selectedPricingPackagesByCategory: Map<number, PricingPackage> = new Map<number, PricingPackage>();
  

  emitCheckPropertyEvent: boolean = true;
  showContactSupportModal: boolean = false;
  requestDocumentPriceName: string;
  shouldOpenModal: boolean = false;
  isLoadingEntryDates: boolean = false;
  digitizationServiceApproximatePricing: { [key: string]: string };

  digitizationServiceForm: UntypedFormGroup
  getCategoryLongName = NameFinderUtils.getCategoryLongName;
  subClassLongNameByShortName = new Map<string, string>();


    constructor(private readonly productService: ProductService, private readonly formBuilder: UntypedFormBuilder,
                private readonly bookableServiceService: BookableServiceService, private readonly dialog: MatDialog,
                private readonly savedPropertyService: SavedPropertyService, private readonly loginIdService: LoginIdService,
                private readonly snackbarService: SnackbarService, private readonly cdRef: ChangeDetectorRef,) {
    }

    async ngOnInit(): Promise<void> {
        await this.loginIdService.loginServiceInitialized$.toPromise()
        this.digitizationServiceApproximatePricing = {
            courserv: "ab 89€",
            ownship: "kostenlos",
            farchiv: "ab 5€/ Monat",
            fback: "ab 23€",
            fdestr: "kostenlos",
            benam: "89€ pro Ordner (400 Blatt)",
            repo: "ab 29€"
        };

        this.productService.getDocumentClassByShortname("PLANUN").subscribe(documentClass => {
            sessionStorage.setItem("PLANUN", JSON.stringify(documentClass));
            this.initPlanungSubClassNames(documentClass);
        });

        this.initPbauakDocumentClass();

        const savedPropertyDocuments = sessionStorage.getItem("savedPropertyDocuments")
        if(savedPropertyDocuments){
            this.savedPropertyDocumentContainerList = JSON.parse(savedPropertyDocuments);
        }

        this.pricing = PlatformUtils.getPlatformPricing();
        this.initProducts();
        await this.initBookableServices();
        this.getFixedPricingPackages();
        this.initDigitizationServiceForm();
    }

    /**
     * Init the planung sub class names from a document class. The subclasses are being sorted in a custom order
     *
     * @param documentClass Document class from which the planung sub class names should be initialized
     */
    private initPlanungSubClassNames(documentClass: DocumentClass): void {
        const priority = ["Sanierungsgebiet", "Städtebauliche Entwicklung", "Umlegungsgebiet", "Erhaltungssatzung", "Gestaltungssatzung"]
        this.planungSubClassNames = documentClass.subClasses
                .filter(subClass => subClass.className !== "FLURB" && subClass.className !== "VERSPERRE" && subClass.className !== "BESCHE")
                .map(subClass => subClass.name.replace("Auskunft", "").trim())
                .sort((a, b) => priority.indexOf(a) - priority.indexOf(b))
    }

    /**
     * Initializes the form that is used to get information for the digitization service
     */
    private initDigitizationServiceForm(){
        this.digitizationServiceForm = this.formBuilder.group({
            numberOfFolders: new UntypedFormControl("", Validators.required),
        })

        this.initDigitizationServiceFormControls('ABServices', 'additionalServices', true);
        this.initDigitizationServiceFormControls('Versand', 'shippingServices', false);
        this.initDigitizationServiceFormControls('Rueckversand', 'storageServices', false);
    }

    /**
     * Adds form controls (checkboxes and radio buttons) to the digitizationServiceForm for all services of a specific service category.
     * Differentiates between checkboxes and radio buttons:
     *
     * Checkboxes:
     *  Per short name of a service a new FormControl is created. To check if a specific service was selected a boolean is used
     * Radio-buttons:
     *  A general FormControl with the name of the formControlName variable is created. To check if a specific service
     *  was selected the short name of the selected service is used
     *
     * @param serviceCategory ServiceCategory for which the FormControl of the respective services should be created
     * @param formControlName Name of the FormControl that should be created
     * @param isCheckbox Determines if the created FormControls should be handled for a checkbox or a radio button
     */
    private initDigitizationServiceFormControls(serviceCategory: string, formControlName: string, isCheckbox: boolean){
        if(this.bookableServicesByCategory.get(serviceCategory)){
            if(!this.digitizationServiceForm.get(formControlName)){
                this.digitizationServiceForm.addControl(formControlName, this.formBuilder.group({}));
            }

            if(isCheckbox){
                (this.bookableServicesByCategory.get(serviceCategory) as Array<BookableService>).forEach(service => {
                    (this.digitizationServiceForm.get(formControlName) as FormGroup).addControl(service.shortName, new FormControl<boolean>(false));
                });
            }
            else{
                (this.digitizationServiceForm.get(formControlName) as FormGroup).addControl(formControlName, new FormControl<string>('', Validators.required));
            }
        }
    }

    /**
     * Initializes all products from the category "Bauaktenarchivbesuche" by putting them into and extra array
     */
    public initBauakProducts(): void{
        for(let product of this.productsByCategory.get("Bauaktenarchivbesuche")){
          // Filter hout 'bauakms' since it is not a product that can be ordered by the user directly.
          // It is added automatically if the user orders 'bauak' and 'statik' together
          if(product.nameShort !== "bauakms"){
            this.bauakProducts.push(product);
          }
        }
    }

    /**
     * Initializes the Grundakte category products by retrieving them
     * from the productsByCategory map and adding them to the grundakten array.
     *
     * @return {void} This method does not return a value.
     */
    public initGrundakteProducts(): void {
      for (const product of this.productsByCategory.get("Grundakte")) {
        this.grundakten.push(product);
      }
    }

    /**
     * Puts products from the category "Planungsrechtauskünfte" into its own sub categories
     */
    public initPlanungProducts(): void {
        for (let product of this.productsByCategory.get(this.keys[5])) {
            let productName = product.nameShort;
            let category = "";

            switch (productName) {
                case "bebauu":
                case "fläche":
                    category = "Pläne";
                    break;
                case "bid":
                case "flurb":
                case "besche":
                case "planun":
                    category = "Satzungs- und Gebietsauskünfte";
                    break;
                case "nwlsch":
                case "hwsch":
                case "baulsch":
                    category = "Schutzgebiete";
                    break;
                case "städte":
                    category = "Sonstige Auskünfte";
                    break;
                default:
                    break;
            }

            if (category !== "") {
                this.addProductToCategory(category, product);
            }
        }
    }

    /**
     * Adds a product to a specific category. This function is used for products of the category "Planungsrechtauskünfte"
     * to divide the products into sub categories.
     *
     * @param category Category of the products
     * @param product Product that should be added to a category
     */
    public addProductToCategory(category: string, product: Product): void {
        if (this.planungProductsByCategory.has(category)) {
            // If the category already exists in the map, append the product to already present products
            const products = this.planungProductsByCategory.get(category) || [];
            products.push(product);
            this.planungProductsByCategory.set(category, products);
        } else {
            // If the category does not exist create a new array and add the product
            this.planungProductsByCategory.set(category, [product]);
        }
    }

    /**
     * Initializes all service categories and all bookable services mapped by their service categories
     */
    public async initBookableServices(): Promise<void> {

        const getBookableServicesByCategoryObservable = this.bookableServiceService.getBookableServicesByCategoryFromStorageOrApi({headers: new HttpHeaders({'showing-spinner': ''})}).toPromise();
        const getServiceCategoriesObservable = this.bookableServiceService.getServiceCategoriesFromStorageOrApi({headers: new HttpHeaders({'showing-spinner': ''})}).toPromise();

        const [bookableServicesByCategory, serviceCategories] = await Promise.all([
            getBookableServicesByCategoryObservable,
            getServiceCategoriesObservable
        ]);

        this.bookableServicesByCategory = new Map<string, BookableService[]>(Object.entries(bookableServicesByCategory));
        this.serviceCategories = serviceCategories

    }

  /**
   * Initializes the available products.
   * Stores categorized products in a map and also all flattened products in a single array.
   * Initializes specific product subsets after the normal products are initialized (planung, bauak)
   */
  public initProducts(): void {
    this.productService.getProductByCategory({headers: new HttpHeaders({'showing-spinner': ''})}).subscribe(productsMap => {
      this.productsByCategory = new Map<string, Product[]>(Object.entries(productsMap));
      // Flatten all products from the map and set it to this.products
      this.products = [];

      // remove bewila, bewild and bewil products since they are not orderable directly - apply filter to all categories
      for (const [key, products] of this.productsByCategory.entries()) {
        this.productsByCategory.set(
          key,
          products.filter(product => !ProductsContainerComponent.UNORDERABLE_PRODUCTS.includes(product.nameShort))
        );
      }

      for (const productArray of this.productsByCategory.values()) {
        this.products.push(...productArray);
      }
      // remove bewila, bewild and bewil products since they are not orderable directly
      this.products = this.products.filter(product => !ProductsContainerComponent.UNORDERABLE_PRODUCTS.includes(product.nameShort));
      this.keys = Object.keys(productsMap);

      this.initPlanungProducts();
      this.initBauakProducts();
      this.initGrundakteProducts();
    });
  }

  /**
   * Handles pricing package selection.
   * If the same package is selected again, deselect it and all its documents are removed.
   * Otherwise any previous selected package is removed and add the documents for the newly selected package.
   *
   * @param pricingPackage Pricing package object that should be selected.
   */
  public onPackageSelection(pricingPackage: PricingPackage): void{
      this.getSelectedProperty.emit();
      const currentSelected = this.selectedPricingPackagesByCategory.get(pricingPackage.categoryId);
      const isSamePackage = currentSelected === pricingPackage;

      if(isSamePackage){
        this.selectedPricingPackagesByCategory.delete(pricingPackage.categoryId);
        this.removeExplicitDocumentsFromPricingPackage(pricingPackage);
      }
      else{
        if(currentSelected){
          this.removeExplicitDocumentsNotInNewPackage(currentSelected, pricingPackage);
        }

        this.addDocumentsFormPricingPackage(pricingPackage);
        this.selectedPricingPackagesByCategory.set(pricingPackage.categoryId, pricingPackage);

        if(this.emitCheckPropertyEvent){
          this.checkProperty.emit();
        }
      }
  }

  /**
   * Adds a single document to the documents array.
   *
   * @param documentShortName Short name of the document that should be added to the documents array
   * @param information (Optional) information that should be part of the document
   */
  addDocumentToDocumentsArray(documentShortName, information){
    if(!this.hasDocument(documentShortName)){
      let tmpDocument = new Document(documentShortName);
      tmpDocument.information = information;
      tmpDocument.partDescription = null;
      this.documents.push(tmpDocument);
    }
  }

  /**
   * Toggles a document in the list based on whether it is already present or not.
   * Handles special cases like contact for pricing overlays and product value requirements
   *
   * @param documentShortName Short name of the document that should be added
   * @param information (Optional) information that should be part of the added document
   */
  public addDocument(documentShortName: string, information: string): void {
    if (this.shouldShowPricingContactOverlay(documentShortName)) {
      this.openRequestDocumentPricingContactOverlay(documentShortName);
      return;
    }

    if (this.emitCheckPropertyEvent) {
      this.checkProperty.emit();
    }

    if(this.shouldOpenModal){
      if (!this.hasDocument(documentShortName)) {
        this.getSelectedProperty.emit();
        if (this.handleSpecialDocuments(documentShortName)) {
          return;
        }
        this.handleProductValueRequirements(documentShortName, information);
        return;
      }

      this.removeDocument(documentShortName);
      this.findNextDocumentPackage();
    }
  }

  findNextDocumentPackage() {
    this.selectedPricingPackagesByCategory.clear();
    if (this.fixedPricingPackages) {
      let sortedFixedPricingPackages = [...this.fixedPricingPackages].sort((a, b) => a.explicitDocuments.length - b.explicitDocuments.length);
      packageLoop:
        for (let fixedPricingPackage of sortedFixedPricingPackages) {
          for (let explicitDocument of fixedPricingPackage.explicitDocuments) {
             const matchingDocument = this.documents.find(d => d.docname === explicitDocument.documentName);
             if (!matchingDocument) {
              continue packageLoop;
            }
            if (!PackageSelectionUtils.isExplicitDocumentSelectionMatch(matchingDocument, explicitDocument)) {
              continue packageLoop;
            }
          }
          this.selectedPricingPackagesByCategory.set(fixedPricingPackage.categoryId, fixedPricingPackage);
        }
    }
  }

  addAdditionalInformation(name, information) {
    this.documents.forEach(function (item) {
      if (item.docname === name) {
        item.information = information;
      }
    })

  }

  displayInfos() {
    this.displayInfo = true;
  }

  hasExplicitDocuments(names: string[]) {
    for (let name of names) {
      let hasDocument = this.hasDocument(name);
      if (!hasDocument)
        return false;
    }
    return true;
  }

  isPackageSelected(pricingPackage: PricingPackage) {
    return this.selectedPricingPackagesByCategory.get(pricingPackage.categoryId) === pricingPackage;
  }

  hasDocument(name) {
    let hasDocument = false;
    this.documents.forEach(function (document) {
      if (document.docname === name)
        hasDocument = true
    });
    return hasDocument;
  }

  /**
   * Checks if there is any document present that matches any product in the given category by name.
   *
   * @param {Array} category - An array of product objects, where each product must have a "nameShort" property.
   * @return {boolean} - Returns true if any of the document names match any product name from the category, otherwise returns false.
   */
  hasAnyDocumentFromCategory(category: any): boolean {
    const productNames = Array.isArray(category)
        ? category.map(p => p?.nameShort).filter(Boolean)
        : [];

    const documentNames = Array.isArray(this.documents)
        ? this.documents.map(d => d?.docname).filter(Boolean)
        : [];

    return documentNames.some(name => productNames.includes(name));
  }

  /**
   * Checks whether or not the document pricing of user pricing contains a specific document or not
   *
   * @param productShortName short name of a product
   * @returns true if the document pricing of the user pricing contains the specific document else false
   */
  containsUserDocumentPricingSpecificDocument(productShortName): boolean {
    if (this.pricing?.documentPricing) {
      if (this.containsUserDocumentPricingSpecificKey(productShortName) || productShortName === 'leitung' || productShortName === 'objaufn' || productShortName === 'bauak') {
        return true;
      }
    }
    return false;
  }

  /**
   * Checks whether or not the user pricing type is 'DOCUMENT' or not
   *
   * @returns true if the user pricing exists and is of type 'DOCUMENT' else false
   */
  isUserPricingTypeDocument(): boolean {
    return this.pricing && this.pricing.pricingType.toString() === 'DOCUMENT'
  }

  /**
   * Checks whether or not the document pricing map contains a specific product short name as key, ignoring case.
   *
   * @param productShortName short name of a product
   */
  containsUserDocumentPricingSpecificKey(productShortName) : boolean{
    return this.pricing.documentPricing[productShortName] || this.pricing.documentPricing[productShortName.toUpperCase()];
  }

  /**
   * Closes the contact overlay component for requesting a document pricing if no pricing is present.
   * Resets the requestDocumentPriceName.
   */
  closeRequestDocumentPricingContactOverlay(){
    this.showContactSupportModal = false;
    this.requestDocumentPriceName = undefined;
  }

  /**
   * Opens the contact overlay component for requesting a document pricing if no pricing is present.
   * Prevents checkPropertyEvent for adding a property.
   *
   * @param documentShortName short name of a document
   */
  openRequestDocumentPricingContactOverlay(documentShortName){
    this.showContactSupportModal = true;
    this.requestDocumentPriceName = this.getProductNameByShortName(documentShortName)
    if (this.contactOverlayComponent) {
      this.contactOverlayComponent.ngOnInit();
    }
    this.emitCheckPropertyEvent = false;
  }

  addInfos(name) {
    this.infoRequest.emit(name);
  }

    /** Opens the Bauakten modal */
    public openBauaktenModal(): void {
      this.getSelectedProperty.emit()
        this.checkProperty.emit();
        if (this.shouldOpenModal) {
            this.startBauakModalOnGrundeStep = false;
            this.pendingBauakPackageSelection = undefined;
            this.showBauaktenModal = true;
        }
    }

    openLeitungPricingOnRequestInformationModal(documentNameShort: string) {
        this.checkProperty.emit();
        if (this.shouldOpenModal) {
            this.showLeitungPricingOnRequestInformation = true;
            this.leitungDocumentNameShort = documentNameShort;
        }
    }

    openBewilModal(): void {
      this.getSelectedProperty.emit();
      this.checkProperty.emit();
      if (this.shouldOpenModal) {
        this.showBewilModal = true;
      }
    }

  closeLeitungPricingOnRequestInformationModal() {
    this.showLeitungPricingOnRequestInformation = false;
  }

    /**
     * closing the digitization service information modal
     */
  public closeDigitizationServiceInformationModal(): void{
      this.digitizationServiceForm.reset();
      this.showDigitizationServiceInformation = false;
  }

    addLeitungDocument() {
        if (!this.hasDocument("leitung")) {
            this.addDocument(this.leitungDocumentNameShort, null);
        }
        this.closeLeitungPricingOnRequestInformationModal();
    }

    /**
     * closes the model for "Bauakten". Resets all values if no bauakten document was put in the cart
     */
  cancelBauaktenDocuments() {
    this.showBauaktenModal = false;
    this.startBauakModalOnGrundeStep = false;
    this.pendingBauakPackageSelection = undefined;
  }

  /**
   * Closes the modal for 'bewil' documents.
   */
  cancelBewilDocuments(): void {
    this.showBewilModal = false;
  }

  /**
   * Handles the removal request for a Grundakte document.
   * Executes the removal of the specific document identified by its name
   * and cancels any associated Bewil documents.
   */
  onGrundakteRemoveRequested(): void {
    this.removeGrundakteDocumentByDocname();
    this.cancelBewilDocuments();
  }

  /**
   * Handles the submission of Grundakte documents by performing several actions such as
   * removing prior related documents, updating the documents list, canceling associated
   * documents, and emitting changes to update the property form.
   *
   * @param {Document[]} documents - The array of Grundakte documents being submitted.
   */
  onGrundakteSubmitted(documents: Document[]): void {
    this.removeGrundakteDocumentByDocname();
    this.documents.push(...documents);
    this.cancelBewilDocuments();
    this.findNextDocumentPackage();
    this.updatePropertyForm.emit();
    this.cdRef.detectChanges();
  }

    /**
     * Tries to find a document in this.document which is a bauakten document.
     *
     * @return Returns the document when a bauakten document can be found else null
     */
    public findBauaktenDocument(): Document | null {
      const docs = this.documents ?? [];

      // Prefer combined document if it exists
      const combined = docs.find(d => (d?.docname || '').toLowerCase() === 'bauakms');
      if (combined) {
        return combined;
      }

      // Otherwise return the first document matching any Bauak product short name
      return (docs.find(d => this.bauakProducts.some(product => d.docname === product.nameShort)) ?? null);
    }

  /**
   * Searches the collection of documents and returns the first document
   * that matches the name of 'bewilu'
   *
   * @return {Document|null} The matching document if found, otherwise null.
   */
  public findBewilDocument(): Document | null {
      const docs = this.documents ?? [];

      return docs.find(d => d.docname === 'bewilu') ?? null;
    }

    getFixedPricingPackages(): void {
        if (!this.pricing?.pricingPackages ||this.pricing.pricingPackages.length === 0) {
            this.fixedPricingPackages = [];
        } else {
            this.fixedPricingPackages = this.pricing.pricingPackages.filter(pPackage => {
                return pPackage.explicitDocuments.length > 0;
            })
        }
        this.fixedPricingPackages.sort((a, b) => {
          if (a.categoryId !== b.categoryId) {
            return a.categoryId - b.categoryId;
          }
          return a.explicitDocuments.length - b.explicitDocuments.length;
        });

        // using setTimeout here to make sure the pricing packages are rendered in the html template
        setTimeout(() => {
          this.setPackageHeaderHeights();
        })
        this.findNextDocumentPackage();
    }

  getProductNameByShortName(nameShort) {
    nameShort = nameShort.trim();
    let result = nameShort;
    for (let key of this.keys) {
      this.productsByCategory.get(key).forEach(product => {
        if (product.nameShort === nameShort)
          result = product.name_long;
      })
    }
    return result;
  }

  /**
   * Checks if a userPricing for this position is present, else returns 100 as default
   */
  getResearchDepartmentPricing(): number {
    if (this.pricing?.additionalPositions && this.pricing.additionalPositions['abteire'] !== undefined) {
      return this.pricing.additionalPositions['abteire'];
    } else {
      return 100;
    }
  }

    /**
     * remove the bauakten document from this.documents if present
     */
    removeBauaktenDocumentByDocname(): void {
      // Filter out Bauakten-related documents but preserve the original array reference
      const filtered = (this.documents ?? []).filter(document => {
        const docname = (document?.docname || '').toLowerCase();
        const isCombined = docname === 'bauakms';
        const isBauakProduct = this.bauakProducts.some(p => p.nameShort === document?.docname);
        return !(isCombined || isBauakProduct); // keep everything else
      });

      // Mutate in place to avoid breaking the shared reference with property.documents
      this.documents.splice(0, this.documents.length, ...filtered);
    }

    /**
     * Removes Grundakte related documents from the shopping cart while keeping the original array reference intact.
     */
    private removeGrundakteDocumentByDocname(): void {
      const grundakteShortNames = (this.grundakten || [])
        .map(product => (product?.nameShort || '').toLowerCase());

      const filtered = (this.documents ?? []).filter(document => {
        const docname = (document?.docname || '').toLowerCase();
        return !grundakteShortNames.includes(docname);
      });

      this.documents.splice(0, this.documents.length, ...filtered);
    }

    /**
     * Checks if a property is selected.
     * If a property is selected open the modal for the digitization service and updates all values of digitizationServiceForm;
     */
    public openDigitizationServiceModel(): void{
      this.checkProperty.emit();
      if(this.shouldOpenModal){
          this.showInvalidInputs = false;
          this.showDigitizationServiceInformation = true;
          this.updateValuesForExistingDigitizationDocument();
      }
    }

    /**
     * Gets and returns all shortNames of the selected services from the digitizationServiceForm.
     * For Checkboxes: It has to be checked which checkboxes where checked and the respective shortNames are added to the array
     * For Radio-Buttons: The values(shortName) of the respective FormControls are added to the array
     */
    public getAllCheckedDigitizationServices(): string[] {
        const selectedDigitizationServices: string[] = [];
        // Iterate through each control in the form
        Object.keys(this.digitizationServiceForm.controls).forEach(controlName => {
            const control = this.digitizationServiceForm.controls[controlName];

            // Check if the control is a FormGroup
            if (control instanceof FormGroup) {
                // Check if the FormGroup contains only one control. If so the FormGroup represents a radio button.
                if (Object.keys(control.controls).length === 1) {
                    const radioGroupName = Object.keys(control.controls)[0];
                    const radioGroupControl = control.get(radioGroupName);

                    if (radioGroupControl.value) {
                        selectedDigitizationServices.push(radioGroupControl.value);
                    }
                } else {
                    // Iterate through each control within the FormGroup
                    Object.keys(control.controls).forEach(shortName => {
                        const serviceControl = control.controls[shortName];

                        // Check if the service control's value is true (checked)
                        if (serviceControl.value === true) {
                            selectedDigitizationServices.push(shortName);
                        }
                    });
                }
            }
        });
        return selectedDigitizationServices;
    }

    /**
     * If the digitizationServiceForm is valid a document for the digitization service is created and adds all selected services to the digitization services document.
     */
    public addDigitizationDocument(): void{
      if(this.digitizationServiceForm.valid){
          let digitizationDocument = new Document("digitiz");
          digitizationDocument.numberOfFolders = this.digitizationServiceForm.get("numberOfFolders").value;
          const servicesToAdd = this.getAllCheckedDigitizationServices();

          servicesToAdd.forEach(serviceShortName => {
              let tmpService = new Service(serviceShortName);
              digitizationDocument.selectedServices.push(tmpService);
          })

          //remove a possible present old document for the digitization service
          this.removeDocument("digitiz");
          this.documents.push(digitizationDocument);
          this.addDigitizationServiceModalComponent.closeModal();
          this.digitizationServiceForm.reset();
      }
      else{
          this.addDigitizationServiceModalComponent.scrollToTop();
          this.showInvalidInputs = true;
      }
    }

    /**
     * Updates the values of the digitizationServiceForm if a document for the digitization service is present
     * in this.documents with the values of the document
     */
    public updateValuesForExistingDigitizationDocument(): void{
      const foundDigitizationDocument = this.documents.find(doc => doc.docname === "digitiz");

      if(foundDigitizationDocument){
          this.digitizationServiceForm.patchValue({
              numberOfFolders: foundDigitizationDocument.numberOfFolders
          })

          foundDigitizationDocument.selectedServices.forEach(selectedService => {
              Object.keys(this.digitizationServiceForm.controls).forEach(controlName => {
                  const control = this.digitizationServiceForm.controls[controlName];

                  if(control instanceof  FormGroup){
                      // Check if the FormGroup contains only one control. If so the FormGroup represents a radio button.
                      if(Object.keys(control.controls).length === 1){
                          this.updateDigitizationServiceRadioButtons(control, selectedService);
                      }
                      else{
                          this.updateDigitizationServiceCheckboxes(control, selectedService);
                      }
                  }
              })
          })
      }
    }

    /**
     * Helper function to update all values of the digitizationServiceForm regarding the radio buttons
     *
     * @param control FormControl of the digitizationServiceForm which should be updated.
     * @param selectedService Service that was previously selected for a digitization service document
     */
    private updateDigitizationServiceRadioButtons(control: FormGroup, selectedService: Service): void{
        const radioGroupName = Object.keys(control.controls)[0];
        const radioGroupControl = control.get(radioGroupName);

        const selectedServiceNameShort = selectedService.nameShort;

        //Helper variable to check if the selected service is part of the "Versand" or "Rueckversand" services
        const isVersandService = (this.bookableServicesByCategory['Versand'] as Array<BookableService>).some(service => service.shortName === selectedServiceNameShort);
        const isRueckversandService = (this.bookableServicesByCategory['Rueckversand'] as Array<BookableService>).some(service => service.shortName === selectedServiceNameShort);

        if ((isVersandService && radioGroupName === "shippingServices") || (isRueckversandService && radioGroupName === "storageServices")) {
            radioGroupControl.setValue(selectedServiceNameShort);
        }
    }


    /**
     * Helper function to update all values of the digitizationServiceForm regarding the radio buttons
     * @param control FormControl of the digitizationServiceForm which should be updated.
     * @param selectedService Service that was previously selected for a digitization service document
     */
    private updateDigitizationServiceCheckboxes(control: FormGroup, selectedService: Service): void{
        // Iterate through each control within the FormGroup
        Object.keys(control.controls).forEach(shortName => {
            const serviceControl = control.controls[shortName];

            if(shortName === selectedService.nameShort){
                serviceControl.setValue(true);
            }
        });
    }

    /**
     * Removing the digitization document from this.documents after asking the user if it really should be removed.
     */
    removeDigitizationDocument(){
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          width: 'auto',
          data: {
              title: 'Daten löschen?',
              content: 'Sind Sie sicher, dass der Digitalisierungsservice aus dem Warenkorb entfernt werden soll? Alle Angaben gehen verloren.'
          }
      })

        dialogRef.afterClosed().subscribe(result => {
            if(result){
                this.removeDocument("digitiz")
                this.digitizationServiceForm.reset();
                this.addDigitizationServiceModalComponent.closeModal();
            }
        })
    }

    /**
     * Removing the "leitung" document from this.documents after asking the user if it really should be removed.
     */
    public removeLeitungDocument(): void{
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: 'auto',
            data: {
                title: 'Daten löschen?',
                content: 'Sind Sie sicher, dass die Leitungsauskünfte aus dem Warenkorb entfernt werden sollen?'
            }
        })

        dialogRef.afterClosed().subscribe(result => {
            if(result){
                this.removeDocument("leitung")
                this.closeLeitungPricingOnRequestInformationModal();
            }
        })
    }

    /** Receives submitted Bauakten document from child */
    public onBauakSubmitted(bauaktenDocuments: Document[]): void {
        this.removeBauaktenDocumentByDocname();
        this.documents.push(...bauaktenDocuments);
        this.pendingBauakPackageSelection = undefined;
        this.startBauakModalOnGrundeStep = false;
        this.cancelBauaktenDocuments();
        this.findNextDocumentPackage();
        this.updatePropertyForm.emit();
        this.cdRef.detectChanges();
    }

    /** Handles remove request emitted by the child component */
    public onBauakRemoveRequested(): void {
        this.removeBauaktenDocumentByDocname();
        this.pendingBauakPackageSelection = undefined;
        this.startBauakModalOnGrundeStep = false;
        this.cancelBauaktenDocuments();
        this.findNextDocumentPackage();
    }

  /**
   * Handles the actions needed to be performed when the Bauak modal is closed.
   * Resets the selected pricing package and removes associated explicit documents if conditions are met,
   * updates the property form, triggers change detection, and cancels Bauakten documents.
   */
  public onBauakModalClosed(): void {
        if (this.startBauakModalOnGrundeStep && this.pendingBauakPackageSelection) {
            this.selectedPricingPackagesByCategory.delete(this.pendingBauakPackageSelection.categoryId);
            this.removeExplicitDocumentsFromPricingPackage(this.pendingBauakPackageSelection);
            this.updatePropertyForm.emit();
            this.cdRef.detectChanges();
        }
        this.cancelBauaktenDocuments();
    }


    /**
     * Determines if a specific control of a form is valid after it was touched
     *
     * @param control AbstractControl that should be checked
     * @return true if the control is invalid and was touched else false
     */
    hasError(control: AbstractControl): boolean {
        return (control.invalid && control.touched);
    }

    /**
     * Marks all inputs of a form as touched so that possible invalid inputs are displayed
     *
     * @param form for which all inputs should be marked as touched
     */
    markInvalidInputs(form: UntypedFormGroup){
        Object.keys(form.controls).forEach(key => {
            if(form.get(key) instanceof UntypedFormControl){
                form.get(key).markAsTouched()
            }
            if(form.get(key) instanceof UntypedFormArray){
                form.get(key).markAllAsTouched()
            }
        })
    }

    /**
     * Gets a map mapping a saved property id to all ordered documents for the corresponding saved property and their latest order dates.
     * Tries to find the correct document for the savedId in the sessionStorage to reduce loading times.
     *
     * @param savedId Id of a saved property for which the ordered documents and latest order dates should be gotten
     */
    getDocumentsBySavedPropertyId(savedId: string){
        this.savedPropertyDocumentContainerList = JSON.parse(sessionStorage.getItem("savedPropertyDocuments"));

        if(!this.savedPropertyDocumentContainerList){
            this.savedPropertyDocumentContainerList = [];
        }

        const existingSavedPropertyDocumentContainer = this.savedPropertyDocumentContainerList.find(container => container.savedId === savedId);

        if(existingSavedPropertyDocumentContainer){
            this.isLoadingEntryDates = false;
            this.documentEntryDate = new Map([[existingSavedPropertyDocumentContainer.savedId, existingSavedPropertyDocumentContainer.documentEntryDate]]);
        }
        else{
            this.isLoadingEntryDates = true;
            this.getDocumentsForSavedPropertyId(savedId);
        }
    }

    /**
     * Gets a map of all document names of all documents for the SavedProperty with the id savedId and
     * updates the savedPropertyDocumentContainerList in the sessionStorage for a specific saved property id.
     *
     * @param savedId Id of the saved property for which the savedPropertyDocumentContainerList should be updated
     */
    private getDocumentsForSavedPropertyId(savedId: string): void{
        this.savedPropertyService.getDocumentsBySavedId(savedId, this.loginIdService.getCurrentCustomHeadersWithoutSpinner()).pipe(
            tap({
                next: (res) => {
                    this.documentEntryDate = new Map([[savedId, res]]);
                    let savedPropertyDocumentContainer: SavedPropertyDocumentContainer = new SavedPropertyDocumentContainer(savedId, new Map(Object.entries(res)));
                    this.savedPropertyDocumentContainerList.push(savedPropertyDocumentContainer);
                    sessionStorage.setItem("savedPropertyDocuments", JSON.stringify(this.savedPropertyDocumentContainerList));
                    this.isLoadingEntryDates = false;
                }
            })
        ).subscribe();
    }

    /**
     * Determines if the actuality of a specific product os exceeded by taking the latest order date of the product and the productActuality of the product in consideration
     *
     * @param product Product for which the actuality should be checked
     * @return true if the actuality of the product is exceeded else false
     */
    public isActualityExceeded(product: Product): boolean {
        if (product.productActuality && this.savedId) {
            return this.documentEntryDate.get(this.savedId)[product.nameShort] + TimeUnit.toMilliseconds(product.productActuality.amount, TimeUnit[product.productActuality.timeUnit]) <= new Date().getTime();
        } else {
            return false;
        }
    }

  /**
   * Retrieves a sorted array of keys based on a predefined preferred order.
   *
   * @return {string[]} An array of keys sorted according to the preferred order.
   */
  public get sortedKeys(): string[] {
      return this.keys
          .slice(6)
          .sort((a, b) => this.preferredOrder.indexOf(a) - this.preferredOrder.indexOf(b));
    }

    /**
     * Determines if a specific product category as any product that is rotationable
     *
     * @param key category name specifying the category
     * @return true if the category specified contains a product that is rotationable else false
     *
     */
    public containsCategoryRotationableProduct(key: string): boolean{
        return this.productsByCategory.get(key).some(product => product.rotationable)
    }

    /**
     * Checks if all information regarding products are present
     */
    public areAllProductInformationPresent(): boolean{
        return (this.keys && this.keys.length > 0) && (this.serviceCategories && this.serviceCategories.length > 0) &&
                (this.productsByCategory.size > 0) && (this.bookableServicesByCategory.size > 0)
    }

  /**
   * Resets the currently selected pricing package to undefined and triggers change detection.
   */
  public resetSelectedPackage(): void{
      this.selectedPricingPackagesByCategory.clear();
      this.cdRef.markForCheck();
    }

  /**
   * Sets the height of all pricing package headers to the max height among them.
   */
  private setPackageHeaderHeights(): void {
      let maxHeight = 0;

      // Calculate the maximum height among package headers
      this.packageHeads.forEach(packageHead => {
        const height = packageHead.nativeElement.offsetHeight;
        maxHeight = Math.max(maxHeight, height);
      });

      // Set the height of all package headers to the maximum height
      this.packageHeads.forEach(packageHead => {
        packageHead.nativeElement.style.height = maxHeight + 'px';
      });
    }

  /**
   * Handles special documents based on the provided short name and opens an information modal.
   * Currently handles short names of "kampfm", "teilung" and "baulas"
   *
   * @param documentShortName Short name of a document that should be handled
   * @return True if the corresponding document short name is considered a special document and is handled like one, else false
   */
  private handleSpecialDocuments(documentShortName: string): boolean {
    const relevantProducts = this.getRelevantProductsForDocument([documentShortName]);
    const canOpenModal = this.isAllowedToOrder && this.shouldOpenModal;
    const showGrundeInformation = localStorage.getItem('grundeInformationModal');
    const shouldShowModal = canOpenModal && (!this.isConnectOrigin || (this.isConnectOrigin && !showGrundeInformation));
    const commonData = {
      products: relevantProducts,
      selectedProperty: this.selectedProperty
    }

    switch (documentShortName) {
      case "kampfm": {
        if (this.shouldOpenModal) {
          this.openSpecialDocumentDialog(KampfmInformationComponent, commonData, documentShortName);
          return true;
        }
        return false;
      }
      case "teilun":
        if (canOpenModal) {
          this.openSpecialDocumentDialog(TeilunInformationComponent, {
            ...commonData,
            teilungPrice: PricingUtils.getTeilunPricing(),
            isConnectOrigin: this.isConnectOrigin
          }, documentShortName, true, "950px");
          return true;
        }
        return false;
      case "abteire":
        this.checkProperty.emit();
        if (this.shouldOpenModal) {
          this.openSpecialDocumentDialog(ResearchDepartmentInformationComponent, {
            ...commonData,
            researchDepartmentPricing: this.getResearchDepartmentPricing()
          }, documentShortName);
          return true;
        }
        return false;
      case "baulas":
        if (this.selectedProperty.state === "Bayern") {
          this.openSpecialDocumentDialog(BaulasInformationComponent, {}, documentShortName, false);
          return true;
        }
        return false
      case "grunde":
      case "grundb":
        if (shouldShowModal) {
          this.openSpecialDocumentDialog(GrundeInformationModalComponent, {
            ...commonData,
            isConnectOrigin: this.isConnectOrigin
          }, documentShortName, true, "950px");
          return true;
        }
        return false;
      case "bewila":
      case "bewil":
        if (canOpenModal && !this.isConnectOrigin) {
          this.openSpecialDocumentDialog(BewilInformationComponent, commonData, documentShortName, true, "950px");
          return true;
        }
        return false;
    }
    return false;
  }

  /**
   * Opens a modal dialog for a special document and manages ATP number synchronization logic.
   *
   * @template T - The type of the component to be opened in the dialog.
   * @param component - The Angular component used as the modal content.
   * @param data - Data passed into the modal component.
   * @param documentShortName - The identifier of the document for which the modal is opened.
   * @param shouldAddDocument - Whether the document should be added to the property upon confirmation.
   * @param width - The width of the modal dialog (default is '900px').
   */
  private openSpecialDocumentDialog<T>(component: ComponentType<T>, data: any, documentShortName: string, shouldAddDocument: boolean = true, width: string = '900px'): void {
    // Determine which ATP keys are relevant for this document
    const relevantATPKeys = this.getRelevantATPKeysForDocument(documentShortName);
    // Look for an existing ATP number to potentially reuse
    const existingATPValue = this.getExistingATPValue();

    // Pre-fill ATP values if applicable
    this.prefillMissingATPKeys(relevantATPKeys, existingATPValue);

    // Open the dialog
    const dialogRef = this.dialog.open(component, {
      width,
      panelClass: ['has-round-border', 'overflow-dialog'],
      disableClose: true,
      data
    });

    // Handle modal result
    dialogRef.afterClosed().subscribe(result => {
      if (result && shouldAddDocument) {
        this.addDocumentToDocumentsArray(documentShortName, null);
        this.findNextDocumentPackage();
        this.updatePropertyForm.emit();
      } else {
        // Clean up any unused ATP keys we temporarily set
        this.cleanupUnusedATPKeys(documentShortName, relevantATPKeys);
      }
    });
  }


  /**
   * Retrieves ATP-related keys associated with a document's product.
   *
   * @param documentShortName - The short identifier of the document.
   * @returns An array of ATP keys relevant to the given document.
   */
  private getRelevantATPKeysForDocument(documentShortName: string): string[] {
    return this.products.find(p => p.nameShort === documentShortName)?.productValues?.map(pv => pv.key).filter(key => StaticData.ATP_KEYS.includes(key)) ?? [];
  }

  /**
   * Looks for the first available ATP number that has already been entered in the property.
   *
   * @returns The first defined ATP number found, or undefined if none exists.
   */
  private getExistingATPValue(): string | undefined {
    return StaticData.ATP_KEYS
        .map(key => this.selectedProperty.additionalProductValues?.[key])
        .find(value => !!value);
  }

  /**
   * Fills in any missing ATP keys with a known existing ATP value.
   *
   * @param keys - The list of ATP keys relevant to the current document.
   * @param value - The existing ATP value to use.
   */
  private prefillMissingATPKeys(keys: string[], value: string | undefined): void {
    if (!value) return;

    for (const key of keys) {
      if (!this.selectedProperty.additionalProductValues[key]) {
        this.selectedProperty.additionalProductValues[key] = value;
      }
    }
  }

  /**
   * Cleans up temporarily assigned ATP keys if the user canceled the modal.
   *
   * @param documentShortName - The short name of the document that was not confirmed.
   * @param keys - The ATP keys that were temporarily filled in.
   */
  private cleanupUnusedATPKeys(documentShortName: string, keys: string[]): void {
    for (const key of keys) {
      const isUsedInOtherDocs = this.documents.some(doc => {
        // Check other documents (not the one we just canceled) for the key
        if (doc.docname === documentShortName){
          return false;
        }
        return this.products.find(p => p.nameShort === doc.docname)
            ?.productValues?.some(pv => pv.key === key);
      });

      // If no other document still uses the key, remove it from the property
      if (!isUsedInOtherDocs && this.selectedProperty.additionalProductValues) {
        delete this.selectedProperty.additionalProductValues[key];
      }
    }
  }

  /**
   * Removes a document from the documents list and clears associated product values from the selected property.
   *
   * @param documentShortName Short name of the document that should be removed from the documents list
   */
  private removeDocument(documentShortName: string): void {
    this.getSelectedProperty.emit();

    const bauakDocument = this.findBauaktenDocument();
    // Block removal of 'grunde' if any bauak document is already selected
    if(documentShortName === "grunde" && bauakDocument !== null){
      this.snackbarService.showSnackbarByType(
          `Der Grundbuchauszug ist zur Qualitätssicherung obligatorisch und kann nicht entfernt werden, da das Produkt 
          ${NameFinderUtils.getProductLongName(bauakDocument.docname,this.products, null)} ausgewählt ist. Bitte entfernen Sie dieses zunächst aus dem Warenkorb.`,
          "warning", 5000);
      return;
    }

    // block removal of 'grunde' if any bewil document is already selected
    const bewiluDocument = this.findBewilDocument();
    if (documentShortName === "grunde" && bewiluDocument !== null) {
      this.snackbarService.showSnackbarByType(
          `Der Grundbuchauszug ist zur Qualitätssicherung obligatorisch und kann nicht entfernt werden, da das Produkt 
          ${NameFinderUtils.getProductLongName(bewiluDocument.docname,this.products, null)} ausgewählt ist. Bitte entfernen Sie dieses zunächst aus dem Warenkorb.`,
          "warning", 5000);
      return;
    }

    const index = this.documents.findIndex(doc => doc.docname === documentShortName);
    if(index > -1){
      this.documents.splice(index, 1);
    }

    // Ensure products and additionalProductValues exist
    if (!this.products || !this.selectedProperty?.additionalProductValues) {
      return;
    }
    this.removeProductValueFromSelectedProperty(documentShortName);
    this.findNextDocumentPackage();
    this.updatePropertyForm.emit();
  }

  /**
   * Removes all product values related to a specific from the selected property 'additionalProductValues'
   *
   * @param documentShortName Short name of the document for which all product values should be removed
   */
  private removeProductValueFromSelectedProperty(documentShortName: string): void{
    // Products whose values have to be removed from the selected property
    const relevantProducts = this.products.filter(product => product.nameShort === documentShortName);

    relevantProducts.forEach(product => {
      product.productValues?.forEach(productValue => {
        if (productValue?.key) {
          delete this.selectedProperty.additionalProductValues[productValue.key];
        }
      });
    });
  }

  /**
   * Handles whether a product value dialog should be shown when adding a document.
   * If not required, add the document directly, else opens a modal for user input beforehand.
   *
   * @param docName Name of the document for which the requirements should be handled
   * @param information (Optional) information that should be part of the added document
   */
  private handleProductValueRequirements(docName: string, information: string): void {
    if(!this.shouldOpenModal){
      return;
    }

    const relevantProducts = this.getRelevantProductsForDocument([docName]);

    if (!ProductUtils.shouldOpenProductValueDialog(relevantProducts)) {
      // When no product values are present for the product, add the document immediately
      this.addDocumentToDocumentsArray(docName, information);

      if (this.emitCheckPropertyEvent) {
        this.checkProperty.emit();
      }

      this.findNextDocumentPackage();
      return;
    }

    // Open the dialog if product values are present
    const dialogRef = this.dialog.open(ProductValueFormComponent, {
      width: '900px',
      panelClass: 'has-round-border',
      disableClose: true,
      data: {products: relevantProducts, useDialogFunctionality: true, selectedProperty: this.selectedProperty}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.addDocumentToDocumentsArray(docName, information);
        if (this.emitCheckPropertyEvent) {
          this.checkProperty.emit();
        }

        this.findNextDocumentPackage();
      }
    });
  }

  /**
   * Returns all products that are relevant for the given list of document names.
   *
   * @param documentNames Array of document names for which the relevant Products should be determined
   * @return Array of products that are associated with the given documentNames
   */
  private getRelevantProductsForDocument(documentNames: string[]): Product[] {
    return this.products.filter(product => documentNames.includes(product.nameShort));
  }

  /**
   * Determines whether a pricing contact overlay should be displayed.
   *
   * @param docName Name of the document for which should be determined if the overlay should be opened
   * @return True if the pricing contact overlay should be opened, else false
   */
  private shouldShowPricingContactOverlay(docName: string): boolean {
    return this.isUserPricingTypeDocument() && !this.containsUserDocumentPricingSpecificDocument(docName);
  }

  /**
   * Entry point for handling a document package selection.
   * Processes any required special modals and then prompts for product value selection if needed.
   *
   * @param pricingPackage Selected pricing package containing explicit document names.
   */
  private addDocumentsFormPricingPackage(pricingPackage: PricingPackage): void {
    // Check if a property is already selected and exit early if not
    this.checkProperty.emit();
    if (!this.shouldOpenModal){
      return;
    }

    const explicitDocuments = pricingPackage.explicitDocuments;
    const newExplicitDocuments = explicitDocuments.filter(explicitDocument => !this.hasDocument(explicitDocument.documentName));
    const handledDocuments = new Set<string>(); // Will track which documents had special modals shown and confirmed

    // Callback to run if all special modals were handled successfully.
    const proceed = () => {
      // Remove special documents already handled from the list
      const remainingDocuments = newExplicitDocuments.filter(explicitDocument => !handledDocuments.has(explicitDocument.documentName));
      const remainingDocumentNames = remainingDocuments.map(explicitDocument => explicitDocument.documentName);
      const relevantProducts = this.getRelevantProductsForDocument(remainingDocumentNames);

      // If no product values are required, immediately add the documents
      if (!ProductUtils.shouldOpenProductValueDialog(relevantProducts)) {
        this.addExplicitDocumentsFormPricingPackage(pricingPackage);
        this.selectedPricingPackagesByCategory.set(pricingPackage.categoryId, pricingPackage);
        this.openBauakModalOnGrundeStepIfApplicable(pricingPackage);
        return;
      }

      // Open the product value modal with remaining relevant products
      const dialogRef = this.dialog.open(ProductValueFormComponent, {
        width: '900px',
        panelClass: 'has-round-border',
        disableClose: true,
        data: {
          products: relevantProducts,
          useDialogFunctionality: true,
          selectedProperty: this.selectedProperty
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.addExplicitDocumentsFormPricingPackage(pricingPackage);
          this.selectedPricingPackagesByCategory.set(pricingPackage.categoryId, pricingPackage);
          this.openBauakModalOnGrundeStepIfApplicable(pricingPackage);
        }
      });
    };

    // Begin processing special modals sequentially
    this.showSpecialModalsSequentially(newExplicitDocuments.map(explicitDocument => explicitDocument.documentName), proceed, handledDocuments);
  }

  /**
   * Handles any special modals for the provided  names one-by-one.
   * If all modals are confirmed, proceeds with the normal flow. Otherwise, aborts.
   *
   * @param documentNames List of document names to evaluate for special modal handling
   * @param onComplete Callback to un if all special modals were handled and confirmed
   * @param handledDocuments Output set to track which s were actually handled via modals.
   */
  private async showSpecialModalsSequentially(documentNames: string[], onComplete: () => void, handledDocuments: Set<string>): Promise<void> {
    for (const docName of documentNames) {
      // Wait for modal result (if required) for this document
      const {wasHandled, confirmed} = await this.handleSpecialDocumentAsync(docName);

      if (wasHandled) {
        if (!confirmed) {
          // Modal was required but canceled -> stop the whole process;
          return;
        }
        // Only track handled documents if the modal was confirmed
        handledDocuments.add(docName);
      }
    }
    // All modals confirmed - continue with the rest of the package selection logic
    onComplete();
  }

  /**
   * Asynchronously handles special logic by calling the sync 'handleSpecialDocuments' and waiting for the corresponding modal to be resolved
   *
   * @param docName Short name of the document to evaluate
   * @return Promise resolving to an object with:
   *         - wasHandled: Whether the  required special handling
   *         - confirmed: Whether the user completed the modal (true) or canceled it (false)
   */
  private handleSpecialDocumentAsync(docName: string): Promise<{ wasHandled: boolean; confirmed: boolean }> {
    return new Promise(resolve => {
      const wasHandled = this.handleSpecialDocuments(docName) // Determines if a modal is needed

      if (!wasHandled) {
        // Not a special - skip modal and mark as confirmed by default
        resolve({ wasHandled: false, confirmed: true });
        return;
      }

      // Get the most recent opened dialog
      const openedDialogs = this.dialog.openDialogs;
      const dialogRef = openedDialogs[openedDialogs.length - 1];

      // Wasit for the user to close the modal and return whether it was confirmed
      dialogRef.afterClosed().subscribe(result => {
        resolve({ wasHandled: true, confirmed: !!result });
      });
    });
  }

  /**
   * Removes all documents listed in the provided pricing package from the current documents list
   *
   * @param pricingPackage Pricing package whose explicit document should be removed from the documents list
   */
  private removeExplicitDocumentsFromPricingPackage(pricingPackage: PricingPackage): void {
    pricingPackage.explicitDocuments.forEach(explicitDocument => {
      this.removeDocument(explicitDocument.documentName);
    })
    this.findNextDocumentPackage();
  }

  /**
   * Removes explicit documents from the current documents list that are not present in a newly selected pricing package.
   *
   * @param currentPackage Currently selected pricing pacakge whose explicit documents may need to be removed
   * @param newPackage Newly selected pricing package that defines the valid set of explicit documents.
   */
  private removeExplicitDocumentsNotInNewPackage(currentPackage: PricingPackage, newPackage: PricingPackage): void {
    const newDocNames = new Set(newPackage.explicitDocuments.map(doc => doc.documentName));
    // Remove any document that is no longer part of the new package
    currentPackage.explicitDocuments.forEach(explicitDocument => {
      if (!newDocNames.has(explicitDocument.documentName)) {
        this.removeDocument(explicitDocument.documentName);
      }
    });
    this.findNextDocumentPackage();
  }

  /**
   * Adds all explicit documents from the pricing package into the documents list, if they are not already present
   *
   * @param pricingPackage PRicing package whose explicit documents should be added to the documents list
   */
  private addExplicitDocumentsFormPricingPackage(pricingPackage: PricingPackage): void {
    pricingPackage.explicitDocuments.forEach(explicitDocument => {
      if (!this.hasDocument(explicitDocument.documentName)) {
        let tmpDocument = new Document(explicitDocument.documentName);
        tmpDocument.information = null;
        tmpDocument.partDescription = null;
        tmpDocument.selectedServices = (explicitDocument.bookableServices || [])
          .map(serviceShortName => new Service(serviceShortName));
        tmpDocument.subInformations = this.buildSubInformationFromExplicitDocument(explicitDocument);
        if (this.pbauakDocumentClass && explicitDocument.subClasses?.length) {
          tmpDocument.documentClass = this.pbauakDocumentClass;
        }
        if (explicitDocument.pbauakPartDescription) {
          const additionalData = new AdditionalConstructionFileData();
          additionalData.partDescription = explicitDocument.pbauakPartDescription;
          tmpDocument.additionalConstructionFileData = additionalData;
        }
        this.documents.push(tmpDocument);
      }
    })
    this.openBauakModalOnGrundeStepIfApplicable(pricingPackage);
  }

  /**
   * Opens the Bauak modal on the "Grunde" step if all preconditions are met.
   *
   * The modal is shown only if:
   * - The user is allowed to order and modals may be opened
   * - The pricing package contains a Bauak-related product
   * - A Grunde product exists but has not yet been ordered
   * - The flow is not initiated from a connect origin
   *
   * @param pricingPackage Pricing package that my contain the Bauak product
   */
  private openBauakModalOnGrundeStepIfApplicable(pricingPackage: PricingPackage): void {
    // Abort if modal interaction or ordering is not permitted
    if (!this.shouldOpenModal || !this.isAllowedToOrder) {
      return;
    }

    const hasBauakProduct = pricingPackage.explicitDocuments
      .some(explicitDocument =>
        ProductUtils.BAUAK_DOCUMENT_NAMES.includes((explicitDocument?.documentName || '').toLowerCase()) ||
        this.bauakProducts?.some(product => product?.nameShort === explicitDocument?.documentName)
      );

    if (!hasBauakProduct) {
      return;
    }

    // Check whether a Grunde product exists and has not already been ordered
    const grundeProduct = (this.products || [])
      .find(product => ['grunde', 'grundb'].includes((product?.nameShort || '').toLowerCase()));
    const hasExistingGrunde = (this.documents || [])
      .some(document => ['grunde', 'grundb'].includes((document?.docname || '').toLowerCase()));

    // Abort if Grunde is unavailable or already present
    if (!grundeProduct || hasExistingGrunde) {
      return;
    }

    if (this.isConnectOrigin) {
      this.addDocumentToDocumentsArray(grundeProduct.nameShort, null);
      return;
    }

    // Prepare modal state and trigger display (non-connect flow)
    this.startBauakModalOnGrundeStep = true;
    this.pendingBauakPackageSelection = pricingPackage;
    this.showBauaktenModal = true;
  }

  /**
   * Builds SubInformation entries from an explicit pricing package document.
   *
   * Each configured subclass short name is converted into a SubInformation
   * object, optionally enriched with metadata from the PBAUAK document class.
   *
   * @param explicitDocument Explicit pricing package document to extract metadata from
   */
  private buildSubInformationFromExplicitDocument(explicitDocument: PricingPackageExplicitDocument): SubInformation[] {
    // Extract subclass identifiers defined by the pricing package
    const subClassShortNames = explicitDocument.subClasses || [];
    if (!subClassShortNames.length) {
      return [];
    }

    return subClassShortNames.map(shortName => {
      const subInformation = new SubInformation();

      // Resolve subclass metadata if available
      const subClass = this.pbauakDocumentClass?.subClasses?.find(sc => sc.className === shortName);
      if (subClass) {
        subInformation.subClass = subClass;
        subInformation.nameLong = subClass.name;
      }

      // Always set the short name and default state flags
      subInformation.nameShort = shortName;
      subInformation.received = false;
      subInformation.requested = false;
      return subInformation;
    });
  }

  /**
   * Initializes the document class for the PBAUAK document from the session storage.
   * Used to get the long names for subclasses in product packages.
   */
  private initPbauakDocumentClass(): void {
    const cached = sessionStorage.getItem('PBAUAK');
    if(cached){
      this.pbauakDocumentClass = JSON.parse(cached) as DocumentClass;
      return;
    }

    // If not already in session storage fetch sub classes and add controls
    this.productService.getDocumentClassByShortname('PBAUAK').subscribe(documentClass => {
      this.pbauakDocumentClass = documentClass;
      sessionStorage.setItem('PBAUAK', JSON.stringify(documentClass));
    });
  }

  protected readonly NameFinderUtils = NameFinderUtils;
}
